import { useAuth } from "@certn/auth";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const SignupRoute = () => {
  const { i18n } = useTranslation();
  const { loginWithRedirect } = useAuth();

  useEffect(() => {
    // Store subject_id in localStorage before redirect to preserve it through Auth0 flow
    const searchParams = new URLSearchParams(window.location.search);
    const subjectId =
      searchParams.get("subject_id") || searchParams.get("person_id");
    if (subjectId) {
      localStorage.setItem("pending_subject_id", subjectId);
    }

    loginWithRedirect({
      authorizationParams: {
        prompt: "login",
        ui_locales: i18n.language,
        screen_hint: "signup",
      },
      appState: {
        returnTo: "/",
      },
    });
  }, [loginWithRedirect, i18n.language]);
  return null;
};
